import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmailViewerModule } from '@vendasta/galaxy/email-viewer';
import { ConversationPipesModule } from '../../../../../../../pipes';
import DOMPurify from 'dompurify';

export interface EmailPreviewDialogData {
  htmlContent: string;
  textContent: string;
}

@Component({
  selector: 'inbox-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.scss'],
  imports: [
    GalaxyPipesModule,
    MatDialogContent,
    MatDialogClose,
    MatDialogActions,
    MatButton,
    TranslateModule,
    GalaxyEmailViewerModule,
    ConversationPipesModule,
  ],
})
export class EmailPreviewDialogComponent {
  private readonly data = inject(MAT_DIALOG_DATA);
  dialogData: EmailPreviewDialogData = this.data;

  constructor(public dialogRef: MatDialogRef<EmailPreviewDialogComponent>) {}

  // TODO(MEGA-1304): When extracting the email thread from the email body in the backend and saving it in the message.body, this field might not have the the original text content anymore. We will have to reconsider how to handle this
  get textContent(): string {
    return DOMPurify.sanitize(this.dialogData.textContent);
  }
}
